import "swiper/css"
import { register } from "swiper/element/bundle"
import "./scss/global.scss"

import { createApp, defineAsyncComponent } from "vue"
import { gsap, ScrollTrigger } from "@/composeables/gsap"
import debounce from "lodash.debounce"
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
// window.ScrollSmoother = ScrollSmoother;
// ScrollSmoother.create({
//     smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
//     effects: true, // looks for data-speed and data-lag attributes on elements
//     smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
// })

import { createPinia } from 'pinia'
// import { useBreakpoints } from "@vueuse/core";
// import { OnClickOutside } from "@vueuse/components";
// import { ExpandTransition, FadeTransition } from "@bam/transitions";

// Heavy GSAP setup + fancybox are dynamic-imported in mounted() / onIdle below
// so they're code-split into separate chunks and don't block initial JS parse.

let { height: bodyHeight, width: bodyWidth } = document.body.getBoundingClientRect().height;
const handleResize = debounce((entries, observer) => {
    const [ entry, ..._ ] = entries

    const newHeight = Math.round(entry.contentRect.height)
    const newWidth = Math.round(entry.contentRect.width)

    if (newHeight != bodyHeight || bodyWidth != newWidth) {
        bodyHeight = newHeight
        bodyWidth = newWidth
        setVh()
        ScrollTrigger.refresh();
    }
}, 30)
const resizeObserver = new ResizeObserver(handleResize);
resizeObserver.observe(document.body)

function setVh() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
}

const runWhenIdle = (cb) =>
    typeof window.requestIdleCallback === "function"
        ? window.requestIdleCallback(cb, { timeout: 2000 })
        : window.setTimeout(cb, 0);
setVh()
const handleWindowResize = debounce(() => { setVh() }, 50)
window.addEventListener('scroll', setVh, { passive: true })
// window.addEventListener('resize', (event) => { console.log(window.innerHeight); handleWindowResize(event)})
window.addEventListener('orientationchange', handleWindowResize)


Promise
    .all(
        Array.from(document.images)
            .filter(img => !img.complete)
            .map(img => new Promise(resolve => { img.onload = img.onerror = resolve; }))
    )
    .then(() => {
        window.setTimeout(() => { ScrollTrigger.refresh(); }, 0)
    });

// window.addEventListener("hashchange", () => {
//     setVh()
//     ScrollTrigger.refresh()
// })

// document.addEventListener("click", (event) => {
//     const { target } = event
//     const link = target.matches('a[href*="#"]')
//         ? target
//         : target.closest('a[href*="#"]')

//     if (!link) return;

//     const url = new URL(link.getAttribute("href"));
//     if (!(
//         url.protocol === location.protocol
//         && url.origin === location.origin
//         && url.pathname === location.pathname
//     )) {
//         return
//     }

//     event.preventDefault();

//     if (url.hash === "") {
//         history.pushState(null, null, url)
//         gsap.to(window, { scrollTo: { y: 0, autoKill: false } });
//         return
//     }

//     const href = url.hash.split('#').slice(1).join('#')
//     const hrefTarget = document.getElementById(href)
//     if (!hrefTarget) {
//         return
//     }

//     history.pushState(null, null, url)
//     gsap.to(window, { scrollTo: { y: hrefTarget, offsetY: 50, autoKill: false } });
// })

const app = createApp({
    data: () => {
        return {
            // globalSwiperModules: [Pagination, Parallax],
        };
    },
    update() {
        // console.log("vue update")
        ScrollTrigger.refresh()
    },
    mounted() {
        register();

        runWhenIdle(async () => {
            const ANIMATIONS = await import("./animations");
            ANIMATIONS.initSectionPinnedMedia();
            ANIMATIONS.initSectionTextOnImage();
            ANIMATIONS.initSectionProductTeaser();
            ANIMATIONS.initSectionTextMedia();
            ANIMATIONS.initSectionForm();
            ScrollTrigger.refresh();
        });

        runWhenIdle(async () => {
            const { init } = await import("./vanilla/fanybox");
            init();
        });
    },
});

const pinia = createPinia()
app.use(pinia)

// app.config.compilerOptions.isCustomElement = (tag) => {
//     return tag.startsWith('swiper')
// }
// const bps = JSON.parse(
//     getComputedStyle(document.body).getPropertyValue("--bam-breakpoints")
// );
// const breakpoints = useBreakpoints(bps);
// app.config.globalProperties.$breakpoints = breakpoints;

// Eager-load every Vue component except the WebGL scene — that one pulls in
// three.js (~600 KB) and is only used on rare sectionWebgl entries, so we lazy
// import it only when a <webgl-scene> element appears on the page.
const components = import.meta.glob(["./components/**/*.vue", "!./components/WebglScene.vue"], { eager: true });
Object.entries(components).forEach(([path, definition]) => {
    const componentName = path
        .split("/")
        .pop()
        .replace(/\.\w+$/, "");
    app.component(componentName, definition.default);
});

if (document.querySelector("webgl-scene, [is='webgl-scene']")) {
    app.component(
        "WebglScene",
        defineAsyncComponent(() => import("./components/WebglScene.vue"))
    );
}

// app.component("expand-transition", ExpandTransition);
// app.component("fade-transition", FadeTransition);
// app.component("on-click-outside", OnClickOutside);

app.mount("#app");

// Table of contents of blog articles: active section, bottom bar on small screens
if (document.querySelector(".blog-toc")) {
    import("./vanilla/blogToc").then(({ init }) => init());
}
